import { useMemo } from 'react'

export const COMPENSACION_STATUSES = [
  'PAGADO',
  'POR PAGAR',
  'PARCIALMENTE PAGADO',
  'COBRADO',
  'POR COBRAR',
  'PARCIALMENTE COBRADO'
]

export const getTypeByStatus = status => {
  const s = status?.toUpperCase()
  if (['COBRADO', 'POR COBRAR', 'PARCIALMENTE COBRADO'].includes(s)) {
    return 'egreso'
  }
  if (['PAGADO', 'POR PAGAR', 'PARCIALMENTE PAGADO'].includes(s)) {
    return 'ingreso'
  }
  return 'ingreso'
}

export const getCompRowKey = row => {
  if (!row) return null
  return (
    row.idPrincipal ??
    row.id_principal ??
    row.id ??
    row.comprobante ??
    row.numeroFolio ??
    row.folio ??
    row.referenciaCredito ??
    row.egreso?.idPrincipal ??
    row.egreso?.id_principal ??
    row.egreso?.id ??
    row.egreso?.comprobante ??
    row.ingreso?.idPrincipal ??
    row.ingreso?.id_principal ??
    row.ingreso?.id ??
    row.ingreso?.comprobante
  )
}

const isBancoLinkage = item => {
  const nombre = (item?.nombreCuentaBanco || '').toLowerCase()
  const origen = (item?._origen || item?.tipo || '').toLowerCase()
  if (nombre && nombre !== 'caja principal') return true
  if (nombre === 'caja principal') return true
  if (origen === 'banco' || origen === 'caja' || origen === 'gestion') return true
  return false
}

export const useCompensacionData = ({
  egresoFiltrado,
  ingresoFiltrado,
  dataModal,
  seleccionado
}) => {
  return useMemo(() => {
    const nextEgresos = [...egresoFiltrado]
    const nextIngresos = [...ingresoFiltrado]
    const seenEgresos = new Set(nextEgresos.map(getCompRowKey).filter(Boolean))
    const seenIngresos = new Set(nextIngresos.map(getCompRowKey).filter(Boolean))
    const linkageRows = Array.isArray(dataModal?.linkage)
      ? dataModal.linkage.filter(item =>
          COMPENSACION_STATUSES.includes((item?.status || '').toUpperCase()) &&
          !isBancoLinkage(item) &&
          Number(item?.montoTotal ?? item?.montoAbono ?? item?.montoCargo ?? 0) > 0
        )
      : []

    linkageRows.forEach(item => {
      const key = getCompRowKey(item)
      if (!key) return
      const targetType = getTypeByStatus(item.status)
      if (targetType === 'ingreso') {
        if (!seenIngresos.has(key)) {
          nextIngresos.push(item)
          seenIngresos.add(key)
        }
      } else {
        if (!seenEgresos.has(key)) {
          nextEgresos.push(item)
          seenEgresos.add(key)
        }
      }
    })

    const result = {
      egreso: nextEgresos,
      ingreso: nextIngresos,
      seleccionado
    }

    return result
  }, [egresoFiltrado, ingresoFiltrado, dataModal?.linkage, seleccionado])
}
